// Libraries
import { FormGroup } from '@angular/forms';
import * as lodash from 'lodash';

/**
 * Provides a set of methods used for forms.
 */
export class FormUtils {
  /**
   * Convert form control errors into a form errors object.
   * @param form Current form
   * @param formErrors Current form errors
   * @param validationMessages Validation messages
   */
  public static parseErrors(form: FormGroup, formErrors: any, validationMessages: any): any {
    for (const field in formErrors) {
      if (Object.prototype.hasOwnProperty.call(formErrors, field)) {
        // Clear previous error message (if any)
        formErrors[field] = '';
        const control = form.get(field);
        const controlErrors = control && control.errors ? control.errors : null;
        if (control && control.dirty && !control.valid && controlErrors) {
          const messages = validationMessages[field];
          for (const key in controlErrors) {
            if (Object.prototype.hasOwnProperty.call(controlErrors, key)) {
              const value = controlErrors[key];
              // If value is not object, copy error message
              if (!lodash.isObject(value)) {
                formErrors[field] += messages[key] + ' ';
              } else {
                for (const errorKey in value) {
                  if (Object.prototype.hasOwnProperty.call(value, errorKey)) {
                    const errorValue = value[errorKey];
                    if (Object.prototype.hasOwnProperty.call(messages[key], errorValue)) {
                      formErrors[field] += messages[key][errorValue] + ' ';
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return formErrors;
  }

  /**
   * Convert backend errors into a form errors object.
   * @param form Current form
   * @param formErrors Current form errors
   * @param backendErrors Backend errors
   */
  public static parseBackendErrors(form: FormGroup, formErrors: any, backendErrors: any): any {
    for (const field in formErrors) {
      if (Object.prototype.hasOwnProperty.call(backendErrors, field) && backendErrors[field]) {
        if (lodash.isArray(backendErrors[field])) {
          // Copy backend errors
          formErrors[field] = backendErrors[field].map(lodash.capitalize).join('. ') + '.';
        } else if (lodash.isObject(backendErrors[field])) {
          const values = lodash.values(backendErrors[field]);
          // Copy backend errors
          formErrors[field] = values.map(lodash.capitalize).join('. ') + '.';
        } else if (lodash.isString(backendErrors[field])) {
          // Copy backend error
          formErrors[field] = lodash.capitalize(backendErrors[field]);
        }
        // Set field backend error
        if (form) {
          const fieldControl = form.get(field);
          if (fieldControl) {
            fieldControl.setErrors({ backend: true});
          }
        }
      }
    }
    return formErrors;
  }
}
